(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["memento-bouquet-signup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', function(event) {
  if (!event.target.matches('[data-bouquet-preview]')) return;
  event.preventDefault();
  event.target.querySelector('[data-bouquet-feedback]').hidden = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memento-shop-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.memento-shop-browser collection-tabs button');
  if (!button) return;
  button.closest('collection-tabs').querySelectorAll('button').forEach(function(item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
});

  } catch(e) { console.error(e); }
})();
})();
